import request from '@/utils/request'


// 查询用户设置信息列表
export function listSetting(query) {
  return request({
    url: '/cio/cio-setting/list',
    method: 'get',
    params: query
  })
}

// 查询用户设置信息分页
export function pageSetting(query) {
  return request({
    url: '/cio/cio-setting/page',
    method: 'get',
    params: query
  })
}

// 查询用户设置信息详细
export function getSetting(data) {
  return request({
    url: '/cio/cio-setting/detail',
    method: 'get',
    params: data
  })
}

// 新增用户设置信息
export function addSetting(data) {
  return request({
    url: '/cio/cio-setting/add',
    method: 'post',
    data: data
  })
}

// 修改用户设置信息
export function updateSetting(data) {
  return request({
    url: '/cio/cio-setting/edit',
    method: 'post',
    data: data
  })
}

// 删除用户设置信息
export function delSetting(data) {
  return request({
    url: '/cio/cio-setting/delete',
    method: 'post',
    data: data
  })
}
